// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__CqLri","errorLogs":"styles_errorLogs__380iF"};